// extracted by mini-css-extract-plugin
export var copySection = "index-module--copySection--15e3f";
export var desc = "index-module--desc--65433";
export var title = "index-module--title--fc412";
export var whatIs = "index-module--whatIs--c4e3e";